import { IPronunciationSortingParams } from './useQueryPronunciations';

export const BASE_KEY = 'PRONUNCIATIONS';

export const pronunciationKeys = {
  all: () => [BASE_KEY] as const,
  list: (params: IPronunciationSortingParams) => [BASE_KEY, params] as const,
  details: () => [BASE_KEY, 'detail'] as const,
  detail: (id: string | number) => [BASE_KEY, 'detail', id] as const,
};
